import { useContext } from 'react';
import { PanoramaContext } from './PanoramaProvider';
export var usePanorama = function () { return useContext(PanoramaContext); };
//# sourceMappingURL=usePanorama.js.map